import { useMutation } from '@tanstack/react-query';
import { getMemberByFilters } from 'services/api/requests/capacity/resource/resources';

import { IAutocomplete } from '../../../utils/forms/autocomplete';

export const useMemberGroupListAsMutate = ({
	busca,
	limit,
	orderBy = 'nome_membro',
	sort = 'ASC',
}: IAutocomplete) => {
	return useMutation(() =>
		getMemberByFilters({ busca, limit, orderBy, sort })
	);
};
